// extracted by mini-css-extract-plugin
export default {"title":"Statement_title__eTvZG","movements":"Statement_movements__u2e6C","action":"Statement_action__CXbI2"};